(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 5301:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(416);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 416:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./node_modules/preact/compat/jsx-runtime.mjs + 1 modules
var jsx_runtime = __webpack_require__(7997);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/preact/compat/dist/compat.module.js + 1 modules
var compat_module = __webpack_require__(1720);
;// CONCATENATED MODULE: ./images/book2.png
/* harmony default export */ var book2 = ({"src":"/_next/static/media/book2.96f3e7be.png","height":747,"width":1200,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAOVBMVEXm5ubb2trNzcyHh4bx8fH////o6Ojt7e1MaXEfHx/w7+/R0tKSkpJxcXHq6ure3t7n5+fU1NTg4ODxwsCiAAAAEnRSTlP9AzM4UBmh/gAN5tmcbrOKxnfTae0qAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAL0lEQVQImR3Fxw0AIAwAsaOEJHTYf1gk/DGWVXeWgFS4l0n5ayGN3kAjZu7xrPAAGP0BIoOShrEAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./components/Newsletter.tsx





function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var NewsletterForm = function(param) {
    var title = param.title, buttonText = param.buttonText;
    var ref = (0,compat_module.useState)({
        status: "idle"
    }), formState = ref[0], setFormState = ref[1];
    var handleSubmit = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(e) {
            var data, res, json;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        e.preventDefault();
                        setFormState({
                            status: "loading"
                        });
                        data = Object.fromEntries(Array.from(e.currentTarget.elements).filter(function(el) {
                            return !!el.getAttribute("name");
                        })// eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- checked on line above
                        .map(function(el) {
                            return [
                                el.getAttribute("name"),
                                el.value
                            ];
                        }));
                        _ctx.prev = 3;
                        _ctx.next = 6;
                        return fetch("/api/subscribe", {
                            body: JSON.stringify(data),
                            headers: {
                                "Content-Type": "application/json"
                            },
                            method: "POST"
                        });
                    case 6:
                        res = _ctx.sent;
                        _ctx.next = 9;
                        return res.json();
                    case 9:
                        json = _ctx.sent;
                        if (json.error) {
                            setFormState({
                                status: "error",
                                error: String(json.error)
                            });
                        } else {
                            setFormState({
                                status: "success"
                            });
                        }
                        _ctx.next = 17;
                        break;
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](3);
                        console.error(_ctx.t0);
                        setFormState({
                            status: "error"
                        });
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    3,
                    13
                ]
            ]);
        }));
        return function handleSubmit(e) {
            return _ref.apply(this, arguments);
        };
    }();
    return(/*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("form", {
        onSubmit: handleSubmit,
        children: [
            title && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h3", {
                className: "font-bold text-3xl sm:text-5xl leading-tight text-black",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                className: "mt-8 grid grid-cols-2 gap-x-6 gap-y-6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("input", {
                        className: "rounded-lg funny-focus text-base font-bold px-4 py-4 placeholder-gray-500 text-black",
                        type: "text",
                        autoComplete: "name",
                        placeholder: "Imię",
                        "aria-label": "Imię",
                        name: "name"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("input", {
                        className: "rounded-lg funny-focus text-base font-bold px-4 py-4 placeholder-gray-500 text-black",
                        type: "text",
                        autoComplete: "family-name",
                        placeholder: "Nazwisko",
                        "aria-label": "Nazwisko",
                        name: "lastName"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("input", {
                        className: "rounded-lg col-span-2 funny-focus text-base font-bold px-4 py-4 placeholder-gray-500 text-black",
                        type: "email",
                        placeholder: "Email",
                        "aria-label": "Email",
                        "aria-required": "true",
                        name: "email",
                        autoComplete: "email",
                        required: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("button", {
                        type: "submit",
                        disabled: formState.status === "loading",
                        className: "".concat(formState.status === "error" ? "shake-shake" : "", " ").concat(formState.status === "loading" ? "cursor-wait" : "", " h-20 col-span-2 funny-focus text-center inline-block bg-black text-white px-8 py-5 rounded-xl text-2xl font-bold hover:shadow-2xl transition-shadow"),
                        children: formStateToString(buttonText, formState)
                    })
                ]
            })
        ]
    }));
};
function Newsletter() {
    return(/*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
        className: "bg-yellow-300 -mx-8 rounded-3xl p-8 lg:p-16 grid md:grid-cols-2 items-center justify-center h-full gap-x-16 gap-y-16",
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(NewsletterForm, {
                buttonText: "Odbierz rozdział",
                title: "Pobierz rozdział za\xa0darmo!"
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                className: "order-last md:order-first",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(next_image["default"], {
                    src: book2,
                    width: 575,
                    height: 360,
                    alt: ""
                })
            })
        ]
    }));
}
function formStateToString(buttonText, formState) {
    switch(formState.status){
        case "idle":
            return buttonText;
        case "success":
            return(/*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("span", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        className: "h-10 w-10 stroke-green-400 inline-block align-middle -mt-1 -ml-2 mr-2 ping-ping animate-ping",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("path", {
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeWidth: "2",
                            d: "M5 13l4 4L19 7"
                        })
                    }),
                    "Udało się! Sprawdź maila 😁"
                ]
            }));
        case "error":
            return formState.error || "Ups! Coś poszło nie tak 🙈";
        case "loading":
            return(/*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                className: "inline-block spin-spin rounded-full bg-white shadow-sm w-8 h-8",
                children: "⏳"
            }));
    }
}

;// CONCATENATED MODULE: ./components/PillLink.tsx

var variants = {
    primary: "bg-black text-white",
    inverted: "bg-yellow-300 text-black"
};
function PillLink(param) {
    var variant = param.variant, children = param.children, href = param.href;
    return(/*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("a", {
        href: href,
        className: "".concat(variants[variant], " funny-focus text-center md:text-left inline-block mt-6 px-8 py-5 rounded-xl text-2xl font-bold hover:shadow-2xl transition-shadow"),
        children: children
    }));
}

// EXTERNAL MODULE: ./components/SiteHeader.tsx
var SiteHeader = __webpack_require__(1087);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./constants.ts
var constants = __webpack_require__(1438);
// EXTERNAL MODULE: ./images/book.png
var book = __webpack_require__(6);
// EXTERNAL MODULE: ./images/books1.png
var books1 = __webpack_require__(6713);
;// CONCATENATED MODULE: ./images/testimonials/jakub_wasik.jpg
/* harmony default export */ var jakub_wasik = ({"src":"/_next/static/media/jakub_wasik.3e557b5d.jpg","height":128,"width":128,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAIAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAX/xAAcEAACAgMBAQAAAAAAAAAAAAABAwACBAVhB0H/xAAVAQEBAAAAAAAAAAAAAAAAAAABA//EABcRAAMBAAAAAAAAAAAAAAAAAAABERL/2gAMAwEAAhEDEQA/AK+f6BqXbhKrZy1sxWFRBFq0Nu8+ExEQyUbp/9k="});
;// CONCATENATED MODULE: ./images/testimonials/piotr_skrzynski.jpg
/* harmony default export */ var piotr_skrzynski = ({"src":"/_next/static/media/piotr_skrzynski.f05c3362.jpg","height":450,"width":450,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAIAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAfEAACAQQCAwAAAAAAAAAAAAABAgADBAYREhQVMUH/xAAVAQEBAAAAAAAAAAAAAAAAAAACA//EABcRAAMBAAAAAAAAAAAAAAAAAAABEQL/2gAMAwEAAhEDEQA/AJa3xa+qYc7+Jq9ojmilNOylgeQ+kaHqIiJZhTTsP//Z"});
;// CONCATENATED MODULE: ./images/testimonials/tomasz_ganski.jpg
/* harmony default export */ var tomasz_ganski = ({"src":"/_next/static/media/tomasz_ganski.55e5ca14.jpg","height":450,"width":450,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAIAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAX/xAAcEAABBAMBAAAAAAAAAAAAAAABAAIDBAUTIUH/xAAVAQEBAAAAAAAAAAAAAAAAAAADBP/EABgRAAMBAQAAAAAAAAAAAAAAAAABAhED/9oADAMBAAIRAxEAPwCtLRtUN002PjMGpry9zgQD6D3hREVPOVgd09P/2Q=="});
;// CONCATENATED MODULE: ./components/Testimonials.tsx






// import chris from "../images/testimonials/chris_miaskowski.jpg";



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var testimonials = [
    {
        name: "Tomasz Gański",
        title: "CTO @ Just Join IT",
        quote: "\xbbTypeScript na poważnie\xab był dla mnie miłym przypomnieniem jak książki techniczne niegdyś wyglądały. Coraz częściej możemy spotkać się publikacjami, kt\xf3re są transkrypcjami kurs\xf3w wideo albo zlepieniem blogpost\xf3w. Michał podszedł do tematu rzetelnie i\xa0w przejrzysty spos\xf3b przedstawił możliwości i\xa0r\xf3żne smaczki TS-a. Tytuł na pewno nie dla os\xf3b dopiero zaczynających z\xa0programowaniem, a\xa0raczej dla os\xf3b, kt\xf3re z\xa0JS miały styczność.\n\nNajwiększą przeszkodą w\xa0odbiorze książki miałem ze wszystkimi anglojęzycznym tłumaczeniami na język polski. Zdarzały się działy gdzie dopiero w\xa0połowie orientowałem się, że dany wzorzec jest mi dobrze znany. Dla niekt\xf3rych może to być zaleta, dla mnie Michał tutaj m\xf3głby być mniej rzetelny 😉 \n\nZdecydowanie czekam na drugą edycję!",
        avatarUrl: tomasz_ganski
    },
    // {
    //   name: "Chris Miąskowski ",
    //   title: "CEO @ 11Sigma.com",
    //   quote: `Fusce pretium augue non lacus cursus, at hendrerit ligula ultrices.
    //           Morbi at nunc sit amet est viverra lacinia at eget nunc. Sed
    //           scelerisque velit lectus, ut accumsan lorem tincidunt eta saha.`,
    //   avatarUrl: chris,
    // },
    {
        name: "Piotr Skrzyński",
        title: "Pasjonata programowania",
        quote: "Świetna książka niezależnie od poziomu zaawansowania. Kupiłem ją na początku swojej przygody z\xa0TS i\xa0po ponad roku nauki, nadal podpieram się wiedzą w\xa0niej zawartą. Zagadnienia wytłumaczone w\xa0jasny i\xa0czytelny spos\xf3b. Bardzo dobrze zainwestowane pieniądze.",
        avatarUrl: piotr_skrzynski
    },
    {
        name: "Jakub Wąsik",
        title: "Full Stack Developer",
        quote: "\xbbTypeScript na poważnie\xab to świetna pozycja zar\xf3wno dla os\xf3b, kt\xf3re dopiero zaczynają swoją przygodę z\xa0TypeScriptem, jak i\xa0dla tych, kt\xf3rzy pracują z\xa0nim już od dawna. Przyjemnie wprowadza w\xa0świat JavaScriptu z\xa0typami, zaznajamia czytelnika z\xa0podstawowymi zagadnieniami i\xa0w\xa0przystępny spos\xf3b omawia bardziej zaawansowane koncepty zaskakujące nawet doświadczonych programist\xf3w.",
        avatarUrl: jakub_wasik
    }, 
];
function Testimonials() {
    return(/*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("ul", {
                className: "grid max-w-2xl mx-auto gap-y-10",
                children: testimonials.map(function(t) {
                    /*#__PURE__*/ return (0,jsx_runtime/* jsx */.tZ)(Testimonial, _objectSpread({}, t), t.name);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(next_seo_module/* ProductJsonLd */.Qb, {
                productName: "TypeScript na poważnie",
                images: [
                    books1/* default.src */.Z.src,
                    book/* default.src */.Z.src
                ],
                description: "TypeScript na poważnie Michała Miszczyszyna to kurs oraz zaawansowane wskaz\xf3wki i\xa0wzorce. Znajdziesz w\xa0niej wszystko, co potrzebne, aby poznać TS na wylot!",
                brand: "Type of Web",
                manufacturerName: "Type of Web",
                manufacturerLogo: "https://typeofweb.com/apple-touch-icon.png",
                slogan: "To kompendium wiedzy na temat TypeScripta! Znajdziesz w\xa0niej wszystko, co potrzebne, aby nauczyć się programować w\xa0TypeScripcie od podstaw, aż po zaawansowane niuanse, dobre praktyki i\xa0wzorce.",
                releaseDate: "2020-11-30T11:08:13Z",
                gtin13: "9788395736339",
                award: "Bestseller",
                reviews: testimonials.map(function(t) {
                    return {
                        author: t.name,
                        datePublished: "2022-02-01T20:43:24.397Z",
                        reviewBody: t.quote,
                        reviewRating: {
                            bestRating: "10",
                            ratingValue: "10",
                            worstRating: "1"
                        },
                        publisher: {
                            type: "Person",
                            name: t.name
                        }
                    };
                }),
                aggregateRating: {
                    bestRating: "10",
                    ratingValue: "9.0",
                    worstRating: "1",
                    reviewCount: "33"
                },
                offers: [
                    {
                        price: "84.99",
                        priceCurrency: "PLN",
                        priceValidUntil: "2025-01-01",
                        itemCondition: "https://schema.org/NewCondition",
                        availability: "https://schema.org/InStock",
                        url: constants/* host */.h,
                        seller: {
                            name: "Type of Web"
                        }
                    },
                    {
                        price: "120.00",
                        priceCurrency: "PLN",
                        priceValidUntil: "2025-01-01",
                        itemCondition: "https://schema.org/NewCondition",
                        availability: "https://schema.org/InStock",
                        url: constants/* host */.h,
                        seller: {
                            name: "Type of Web"
                        }
                    }, 
                ]
            })
        ]
    }));
}
function Testimonial(param) {
    var name = param.name, title = param.title, quote = param.quote, avatarUrl = param.avatarUrl;
    return(/*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("li", {
        className: "bg-white text-black p-10 funny-border",
        children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("blockquote", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("cite", {
                    className: "grid grid-cols-[1fr_4rem] mb-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("p", {
                                    className: "text-2xl font-bold mb-0.5",
                                    children: name
                                }),
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("p", {
                                    className: "text-gray-500 text-lg",
                                    children: title
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(next_image["default"], {
                                src: avatarUrl,
                                className: "rounded-full w-16 h-16",
                                alt: ""
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                    className: "quote-text flex flex-col gap-y-4",
                    children: quote.split("\n\n").map(function(text, i) {
                        /*#__PURE__*/ return (0,jsx_runtime/* jsx */.tZ)("p", {
                            className: "text-lg font-serif leading-normal",
                            children: text
                        }, i);
                    })
                })
            ]
        })
    }));
}

;// CONCATENATED MODULE: ./components/Toc.tsx

function Toc() {
    return(/*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("ol", {
        className: "ol text-xl md:columns-2 gap-x-16 mb-8",
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("li", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                        className: "font-bold",
                        "aria-hidden": true,
                        children: "1."
                    }),
                    " ",
                    "Wstęp: Po co TypeScript?"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("li", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                        className: "font-bold",
                        "aria-hidden": true,
                        children: "2."
                    }),
                    " ",
                    "TypeScript w 10 minut"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("li", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                        className: "font-bold",
                        "aria-hidden": true,
                        children: "3."
                    }),
                    " ",
                    "Dygresja: Wprowadzenie do przydatnych element\xf3w z ES6+"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("li", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                        className: "font-bold",
                        "aria-hidden": true,
                        children: "4."
                    }),
                    " ",
                    "Typowanie statyczne i\xa0typowanie silne"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("li", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                        className: "font-bold",
                        "aria-hidden": true,
                        children: "5."
                    }),
                    " ",
                    "Typy elementarne"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("li", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                        className: "font-bold",
                        "aria-hidden": true,
                        children: "6."
                    }),
                    " ",
                    "Funkcje"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("li", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                        className: "font-bold",
                        "aria-hidden": true,
                        children: "7."
                    }),
                    " ",
                    "Klasy i interfejsy"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("li", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                        className: "font-bold",
                        "aria-hidden": true,
                        children: "8."
                    }),
                    " ",
                    "Typy generyczne"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("li", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                        className: "font-bold",
                        "aria-hidden": true,
                        children: "9."
                    }),
                    " ",
                    "Inferencja typ\xf3w i const"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("li", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                        className: "font-bold",
                        "aria-hidden": true,
                        children: "10."
                    }),
                    " ",
                    "Kompatybilność typ\xf3w"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("li", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                        className: "font-bold",
                        "aria-hidden": true,
                        children: "11."
                    }),
                    " ",
                    "Enumy"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("li", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                        className: "font-bold",
                        "aria-hidden": true,
                        children: "12."
                    }),
                    " ",
                    "Typy zaawansowane"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("li", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                        className: "font-bold",
                        "aria-hidden": true,
                        children: "13."
                    }),
                    " ",
                    "Typy warunkowe"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("li", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                        className: "font-bold",
                        "aria-hidden": true,
                        children: "14."
                    }),
                    " ",
                    "Unie w praktyce"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("li", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                        className: "font-bold",
                        "aria-hidden": true,
                        children: "15."
                    }),
                    " ",
                    "Bezpieczna praca z danymi"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("li", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                        className: "font-bold",
                        "aria-hidden": true,
                        children: "16."
                    }),
                    " ",
                    "Typy nominalne"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("li", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                        className: "font-bold",
                        "aria-hidden": true,
                        children: "17."
                    }),
                    " ",
                    "Własna walidacja, typy warunkowe i testowanie typ\xf3w"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("li", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                        className: "font-bold",
                        "aria-hidden": true,
                        children: "18."
                    }),
                    " ",
                    "Implementacja systemu jednostek w TS"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("li", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                        className: "font-bold",
                        "aria-hidden": true,
                        children: "19."
                    }),
                    " ",
                    "Migracja z JavaScriptu"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("li", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                        className: "font-bold",
                        "aria-hidden": true,
                        children: "20."
                    }),
                    " ",
                    "Pliki definicji typ\xf3w .d.ts"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("li", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                        className: "font-bold",
                        "aria-hidden": true,
                        children: "21."
                    }),
                    " ",
                    "Popularne problemy z TS"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("li", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                        className: "font-bold",
                        children: "Dodatek:"
                    }),
                    " Przydatne typy"
                ]
            })
        ]
    }));
}

;// CONCATENATED MODULE: ./images/academic-cap.svg
/* harmony default export */ var academic_cap = ({"src":"/_next/static/media/academic-cap.9ac7e710.svg","height":24,"width":24});
;// CONCATENATED MODULE: ./images/autor.jpg
/* harmony default export */ var autor = ({"src":"/_next/static/media/autor.18e34f47.jpg","height":900,"width":1200,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAGAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAX/xAAfEAABAwQDAQAAAAAAAAAAAAABAAIDBAURMRITYSH/xAAUAQEAAAAAAAAAAAAAAAAAAAAC/8QAFREBAQAAAAAAAAAAAAAAAAAAAAH/2gAMAwEAAhEDEQA/AJ9De7sJaunknje6Bok7uJDyw4xo789P1ERCk//Z"});
;// CONCATENATED MODULE: ./images/chip.svg
/* harmony default export */ var chip = ({"src":"/_next/static/media/chip.8ca7fb19.svg","height":24,"width":24});
;// CONCATENATED MODULE: ./images/clipboard-list.svg
/* harmony default export */ var clipboard_list = ({"src":"/_next/static/media/clipboard-list.39966b23.svg","height":24,"width":24});
;// CONCATENATED MODULE: ./images/cog.svg
/* harmony default export */ var cog = ({"src":"/_next/static/media/cog.3cf87699.svg","height":24,"width":24});
;// CONCATENATED MODULE: ./images/color-swatch.svg
/* harmony default export */ var color_swatch = ({"src":"/_next/static/media/color-swatch.2605b732.svg","height":24,"width":24});
;// CONCATENATED MODULE: ./images/desktop-computer.svg
/* harmony default export */ var desktop_computer = ({"src":"/_next/static/media/desktop-computer.b47dbffd.svg","height":24,"width":24});
;// CONCATENATED MODULE: ./images/typescript-na-powaznie-ebook.png
/* harmony default export */ var typescript_na_powaznie_ebook = ({"src":"/_next/static/media/typescript-na-powaznie-ebook.2e1db7f9.png","height":643,"width":1200,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAATlBMVEUcNXNpjsNglsdNaJBWhKVSd5VKW2wODy9HT1szO0kZGSi3ydlGXZYOFDkTIlEcHDqjtMNQaJEuXI4gLFe7wso+bKyuw9XC0NxISVU0NUl/WHdqAAAAE3RSTlP+/f35eVOTSKifK9a5t7IuzfmzjXBk9wAAAAlwSFlzAAALEwAACxMBAJqcGAAAADFJREFUCJkFwYUBACAMA7DirmPI/4+SIDp/X3ANhQggqsishBw8kfY6Z+0Oo23wVpsPLpgB/GgZbbMAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./pages/index.tsx


















var isSellingPrinted = false;
var price = /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
    children: [
        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("del", {
            className: "decoration-red-600 decoration-2 text-gray-500",
            children: "120\xa0zł"
        }),
        " ",
        "84,99\xa0zł"
    ]
});
var NewEditionPill = function() {
    return isSellingPrinted ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("p", {
        className: "px-4 py-1 mr-4 bg-transparent text-black uppercase font-bold border-4 border-blue-600 text-2xl inline-block rounded-full",
        children: "Nowe wydanie"
    }) : null;
};
function Home() {
    return(/*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(SiteHeader/* SiteHeader */.H, {}),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("section", {
                id: "hero",
                className: "py-36 min-h-screen bg-yellow-300 grid -mb-8",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                    className: "container grid md:grid-cols-2 gap-y-16 gap-x-16 items-center justify-center h-full",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                            className: "xl:-mt-16",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(NewEditionPill, {}),
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("p", {
                                    className: "px-4 py-1 bg-red-600 text-white font-bold inline-block rounded-full",
                                    children: "Bestseller"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h2", {
                                    className: "mt-4 text-5xl font-bold leading-snug",
                                    children: "Zostań mistrzem TypeScripta zaledwie w\xa0kilka dni!"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("p", {
                                    className: "text-2xl leading-normal mb-2 mt-4 font-light",
                                    children: "Kurs i\xa0poradnik programowania w\xa0TypeScript."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("p", {
                                    className: "text-2xl leading-normal mt-2 mb-4 font-light",
                                    children: "Ponad 300 stron praktycznej wiedzy!"
                                }),
                                isSellingPrinted ? /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(PillLink, {
                                    variant: "primary",
                                    href: "",
                                    children: [
                                        "Kup książkę teraz za ",
                                        price
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(PillLink, {
                                            variant: "primary",
                                            href: "https://sklep.typeofweb.com/",
                                            children: [
                                                "Kup ebooka teraz za ",
                                                price
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("p", {
                                            className: "mt-8 text-xl -mb-4 leading-normal font-light",
                                            children: "Lub zgłoś zainteresowanie dodrukiem:"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(NewsletterForm, {
                                            title: "",
                                            buttonText: "Poinformuj mnie gdy wr\xf3ci do druku"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                            className: "order-last md:order-first text-center",
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(next_image["default"], {
                                placeholder: "blur",
                                priority: true,
                                src: books1/* default */.Z,
                                width: 576,
                                height: 460,
                                alt: ""
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("section", {
                id: "o-ksiazce",
                className: "min-h-screen p-section bg-white grid rounded-t-[2rem] -mb-8",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                    className: "container grid lg:grid-cols-2 items-center justify-center h-full gap-x-16 gap-y-16",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                            className: "lg:-mt-10",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h2", {
                                    className: "mt-4 text-5xl font-bold leading-snug",
                                    children: "TypeScript na poważnie"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(NewEditionPill, {}),
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("p", {
                                    className: "text-2xl leading-normal my-4 font-light",
                                    children: "Ta książka zawiera wszystko, co potrzebne, aby w\xa0pełni korzystać z TypeScripta! Zebrałem w\xa0niej swoją wiedzę, wieloletnie doświadczenie, dobre praktyki i\xa0wzorce."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("ul", {
                                    className: "mt-8 text-xl font-light leading-relaxed list-inside",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("li", {
                                            className: "tick",
                                            children: [
                                                "Czym jest ",
                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("strong", {
                                                    children: "TypeScript"
                                                }),
                                                "?"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("li", {
                                            className: "tick",
                                            children: [
                                                "Jak ",
                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("strong", {
                                                    children: "bezpiecznie"
                                                }),
                                                " budować aplikacje?"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("li", {
                                            className: "tick",
                                            children: [
                                                "Jak ",
                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("strong", {
                                                    children: "projektować"
                                                }),
                                                " typy?"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("li", {
                                            className: "tick",
                                            children: [
                                                "Jak opisać typami ",
                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("strong", {
                                                    children: "walidację"
                                                }),
                                                " w\xa0trakcie działania programu?"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("li", {
                                            className: "tick",
                                            children: [
                                                "Jak prawidłowo otypować ",
                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("strong", {
                                                    children: "dane z\xa0API"
                                                }),
                                                "?"
                                            ]
                                        })
                                    ]
                                }),
                                isSellingPrinted ? /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(PillLink, {
                                    variant: "inverted",
                                    href: "",
                                    children: [
                                        "Kup książkę teraz za ",
                                        price
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(PillLink, {
                                    variant: "inverted",
                                    href: "https://sklep.typeofweb.com/",
                                    children: [
                                        "Kup ebooka teraz za ",
                                        price
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                            className: "text-center",
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(next_image["default"], {
                                placeholder: "blur",
                                src: book/* default */.Z,
                                alt: "",
                                width: 300,
                                height: 475,
                                className: "drop-shadow- 2xl"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("section", {
                id: "opinie",
                className: "min-h-screen p-section bg-gray-800 text-white grid items-center grid-rows-1 rounded-t-[2rem] -mb-8",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                    className: "container xl:-mt-16",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h2", {
                            className: "mb-8 text-4xl text-center font-bold leading-snug self-end",
                            children: "Co m\xf3wią czytelnicy?"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Testimonials, {})
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("section", {
                id: "o-autorze",
                className: "min-h-screen p-section bg-white grid rounded-t-[2rem] -mb-8",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                    className: "container grid lg:grid-cols-2 gap-x-16 items-center justify-center h-full",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                            className: "md:-mt-10",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h2", {
                                    className: "mt-4 text-5xl font-bold leading-snug",
                                    children: "O autorze"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("p", {
                                    className: "text-xl leading-normal my-4 font-normal",
                                    children: "Cześć! Nazywam się Michał i\xa0bardzo się cieszę, że tu jesteś!"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("p", {
                                    className: "text-xl leading-normal my-4 font-normal",
                                    children: [
                                        "Na co dzień zajmuję się programowaniem, a\xa0od czterech lat tworzę bloga ",
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("strong", {
                                            children: "Type of Web"
                                        }),
                                        ", kt\xf3ry jest jednym z najpopularniejszych blog\xf3w programistycznych w\xa0Polsce. Poza tym mogliśmy się spotkać na r\xf3żnych konferencjach i\xa0meetupach, kt\xf3re wsp\xf3łorganizowałem, występowałem na nich lub byłem patronem."
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("p", {
                                    className: "text-xl leading-normal my-4 font-normal",
                                    children: "Wsp\xf3łpracuję przede wszystkim z\xa0zespołami w\xa0USA i\xa0buduję aplikacje Internetowe z\xa0wykorzystaniem r\xf3żnych technologii (TypeScript, Golang, Scala)."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("p", {
                                    className: "text-3xl leading-normal my-6 font-normal italic",
                                    children: "Michał Miszczyszyn"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                            className: "order-last lg:order-first lg:-mt-10",
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(next_image["default"], {
                                alt: "",
                                placeholder: "blur",
                                src: autor,
                                className: "funny-border"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("section", {
                id: "kompletny-przewodnik",
                className: "min-h-screen p-section bg-blue-50 text-black grid items-center grid-rows-1 rounded-t-[2rem] -mb-8",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                    className: "container xl:-mt-16",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h2", {
                            className: "mb-8 text-4xl text-center font-bold leading-snug self-end",
                            children: "Kompletny przewodnik"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("ul", {
                            className: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-y-10 md:gap-y-16 gap-x-8",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("li", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(next_image["default"], {
                                            src: academic_cap,
                                            className: "w-16 h-16",
                                            width: "64",
                                            height: "64",
                                            alt: ""
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h3", {
                                            className: "text-2xl font-bold mb-2",
                                            children: "Szybki start z\xa0TypeScriptem"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("p", {
                                            className: "text-lg",
                                            children: [
                                                "Przeprowadzę Cię krok po kroku przez stworzenie projektu i kompletną konfigurację zar\xf3wno",
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("strong", {
                                                    children: "w\xa0Node.js, jak i\xa0na frontendzie"
                                                }),
                                                ". Zajmie to nie więcej, niż 10 minut."
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("li", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(next_image["default"], {
                                            src: chip,
                                            className: "w-16 h-16",
                                            width: "64",
                                            height: "64",
                                            alt: ""
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h3", {
                                            className: "text-2xl font-bold mb-2",
                                            children: "Zaawansowane typy"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("p", {
                                            className: "text-lg",
                                            children: [
                                                "Poznasz niesamowite możliwości, jakie dają typy zaawansowane. Wśr\xf3d nich typy warunkowe, typy mapowane, tworzenie",
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("strong", {
                                                    children: "algebraicznych typ\xf3w danych"
                                                }),
                                                " i\xa0dużo więcej. Dzięki temu będziesz w\xa0stanie pisać kod, kt\xf3ry uniemożliwia popełnienie błęd\xf3w."
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("li", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(next_image["default"], {
                                            src: clipboard_list,
                                            className: "w-16 h-16",
                                            width: "64",
                                            height: "64",
                                            alt: ""
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h3", {
                                            className: "text-2xl font-bold mb-2",
                                            children: "Bezpieczna praca z\xa0danymi"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("p", {
                                            className: "text-lg",
                                            children: [
                                                "Praca z\xa0zewnętrznymi ",
                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("strong", {
                                                    children: "API w\xa0TypeScripcie"
                                                }),
                                                " sprawia Ci problem? Nie czujesz się do końca pewnie? Pokazuję, jak w\xa0pełni bezpiecznie operować na danych w\xa0TS!"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("li", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(next_image["default"], {
                                            src: cog,
                                            className: "w-16 h-16",
                                            width: "64",
                                            height: "64",
                                            alt: ""
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h3", {
                                            className: "text-2xl font-bold mb-2",
                                            children: "Typowanie silne i\xa0statyczne"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("p", {
                                            className: "text-lg",
                                            children: [
                                                "Czym r\xf3żnią się od siebie typy silne, statyczne, dynamiczne i słabe? Co to jest duck typing i\xa0",
                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("strong", {
                                                    children: "typowanie strukturalne"
                                                }),
                                                "? Jakie mają wady i\xa0zalety?"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("li", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(next_image["default"], {
                                            src: color_swatch,
                                            className: "w-16 h-16",
                                            width: "64",
                                            height: "64",
                                            alt: ""
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h3", {
                                            className: "text-2xl font-bold mb-2",
                                            children: "Kompatybilność typ\xf3w"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("p", {
                                            className: "text-lg",
                                            children: [
                                                "Co to znaczy, że typ jest kowariantny? Łagodnie wprowadzę Cię w świat ",
                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("strong", {
                                                    children: "kompatybilności typ\xf3w"
                                                }),
                                                " i\xa0dokładnie wytłumaczę wszelkie niuanse tak, aby żadne zachowanie nie było dla Ciebie zaskoczeniem!"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("li", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(next_image["default"], {
                                            src: desktop_computer,
                                            className: "w-16 h-16",
                                            width: "64",
                                            height: "64",
                                            loading: "lazy",
                                            alt: ""
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h3", {
                                            className: "text-2xl font-bold mb-2",
                                            children: "Typy nominalne"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("p", {
                                            className: "text-lg",
                                            children: [
                                                "Czy TypeScript ma typy nominalne? Czym one są i\xa0do czego się mogą przydać? Jak połączyć je z\xa0",
                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("strong", {
                                                    children: "walidacją"
                                                }),
                                                "? Jak mieć pewność, że pracujemy z\xa0właściwymi danymi?"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("section", {
                id: "dla-kogo",
                className: "min-h-screen pt-32 pb-24 bg-white text-black grid items-center grid-rows-1 rounded-t-[2rem] -mb-8",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                    className: "container m-auto",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h2", {
                            className: "mb-8 text-4xl text-center font-bold leading-snug self-end",
                            children: "Dla kogo ta książka?"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("ul", {
                            className: "grid grid-cols-1 lg:grid-cols-3 gap-x-16",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("li", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h3", {
                                            className: "mt-4 text-3xl font-bold leading-snug",
                                            children: "Książka dla każdego"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("p", {
                                            className: "text-xl leading-normal my-4 font-normal",
                                            children: [
                                                "Niezależnie od tego, czy dopiero ",
                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("strong", {
                                                    children: "zaczynasz"
                                                }),
                                                " ",
                                                "swoją przygodę z programowaniem, czy masz tytuł",
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("strong", {
                                                    children: "seniora"
                                                }),
                                                ", niezależnie, czy tworzysz",
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("strong", {
                                                    children: "front-end"
                                                }),
                                                " z\xa0użyciem popularnych framework\xf3w, czy może piszesz ",
                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("strong", {
                                                    children: "backend w\xa0node.js"
                                                }),
                                                ", na pewno znajdziesz tutaj coś, co zainspiruje i\xa0przekona Cię do używania",
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("strong", {
                                                    children: "TypeScripta"
                                                }),
                                                " na co dzień."
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("li", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h3", {
                                            className: "mt-4 text-3xl font-bold leading-snug",
                                            children: "Tylko praktyka i\xa0doświadczenie"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("p", {
                                            className: "text-xl leading-normal my-4 font-normal",
                                            children: [
                                                "Nie ulega wątpliwości, że ",
                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("strong", {
                                                    children: "statyczne typowanie"
                                                }),
                                                " ",
                                                "eliminuje całą gamę błęd\xf3w wynikających z\xa0niepewności odnośnie typ\xf3w danych. W tej książce nie będziemy wałkować",
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("strong", {
                                                    children: "suchej teorii"
                                                }),
                                                "! Poznasz",
                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("strong", {
                                                    children: "konkretne techniki"
                                                }),
                                                " i\xa0skorzystasz z\xa0mojego",
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("strong", {
                                                    children: "doświadczenia"
                                                }),
                                                " w\xa0pracy z\xa0TypeScriptem przy",
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("strong", {
                                                    children: "ogromnych"
                                                }),
                                                " komercyjnych projektach!"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("li", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h3", {
                                            className: "mt-4 text-3xl font-bold leading-snug",
                                            children: "Od juniora do seniora w\xa0TS"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("p", {
                                            className: "text-xl leading-normal my-4 font-normal",
                                            children: [
                                                "Książka zawiera wszystko, co potrzebne, aby",
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("strong", {
                                                    children: "zacząć od zera"
                                                }),
                                                " i szybko dojść do",
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("strong", {
                                                    children: "zaawansowanej znajomości TypeScripta"
                                                }),
                                                ". Nauczę Cię, jak pisać bezpieczne aplikacje w\xa0TypeScripcie od podstaw, aż po ",
                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("strong", {
                                                    children: "najbardziej szczeg\xf3łowe detale"
                                                }),
                                                " działania TS, kt\xf3re sprawią, że Tw\xf3j kod stanie się jeszcze lepszy."
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h2", {
                            className: "mb-8 mt-32 text-4xl text-center font-bold leading-snug self-end",
                            children: "Co znajdziesz w\xa0książce?"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Newsletter, {})
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("section", {
                id: "spis-tresci",
                className: "pt-4 pb-40 bg-white text-black grid items-center grid-rows-1 rounded-t-[2rem] -mb-8",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                    className: "container m-auto max-w-3xl flex flex-col justify-center items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h2", {
                            className: "mb-8 text-4xl text-center font-bold leading-snug",
                            children: "Spis treści"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Toc, {}),
                        isSellingPrinted ? /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(PillLink, {
                            variant: "inverted",
                            href: "",
                            children: [
                                "Kup książkę teraz za ",
                                price
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(PillLink, {
                            variant: "inverted",
                            href: "https://sklep.typeofweb.com/",
                            children: [
                                "Kup ebooka teraz za ",
                                price
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("section", {
                id: "kup-teraz",
                className: "min-h-screen p-section bg-gray-800 text-white grid items-center grid-rows-1 rounded-t-[2rem] -mb-8",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                    className: "container m-auto max-w-4xl",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h2", {
                            className: "mb-8 text-4xl text-center font-bold leading-snug self-end",
                            children: "Tak! Chcę tę książkę…"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("p", {
                            className: "text-center text-xl mt-8 leading-normal",
                            children: [
                                "„TypeScript na poważnie” to pozycja, kt\xf3ra nauczy Cię wszystkiego, co musisz wiedzieć, aby efektywnie pracować z\xa0TypeScriptem. Jest to",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("strong", {
                                    children: "kompendium wiedzy"
                                }),
                                ", od zera aż po najbardziej zaawansowane techniki i kruczki tego języka programowania. Wszystko poparte jest ",
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("strong", {
                                    children: "praktycznymi przykładami"
                                }),
                                " wziętymi z\xa0prawdziwych projekt\xf3w, nad kt\xf3rymi pracowałem. Pierwsze wydanie było absolutnym bestsellerem, a cały nakład wyprzedał się w\xa0ciągu zaledwie ",
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("strong", {
                                    children: "kilku dni"
                                }),
                                "!"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("p", {
                            className: "text-center text-5xl font-bold my-8",
                            children: [
                                " ",
                                price
                            ]
                        }),
                        isSellingPrinted ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("p", {
                            className: "text-center text-2xl font-bold my-8",
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(PillLink, {
                                href: "",
                                variant: "inverted",
                                children: "Kupuję książkę teraz"
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("p", {
                            className: "text-center text-2xl font-bold my-8",
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(PillLink, {
                                href: "https://sklep.typeofweb.com/",
                                variant: "inverted",
                                children: "Kupuję ebooka teraz"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                            className: "bg-white p-8 rounded-lg mt-16",
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(next_image["default"], {
                                src: typescript_na_powaznie_ebook,
                                alt: "TypeScript na poważnie r\xf3wnież w wersji ebook"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                            className: "bg-yellow-300 rounded-3xl p-8 lg:p-16 mt-16",
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(NewsletterForm, {
                                title: "Zgłoś zainteresowanie dodrukiem:",
                                buttonText: "Poinformuj mnie gdy wr\xf3ci do druku"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("footer", {
                className: "pt-8 pb-8 bg-blue-50 text-black grid items-center grid-rows-1 rounded-t-[2rem] -mb-8",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                    className: "container m-auto max-w-4xl text-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("p", {
                            children: [
                                "\xa9 ",
                                new Date().getFullYear(),
                                " | Wydawnictwo Type of Web - Michał Miszczyszyn",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("a", {
                                    href: "https://typeofweb.com/",
                                    target: "_blank",
                                    rel: "noreferrer noopener",
                                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: 200,
                                        className: "mx-auto my-2",
                                        viewBox: "0 0 632 106",
                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("g", {
                                            fill: "none",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("path", {
                                                    fill: "#161326",
                                                    d: "M.5 12.7 17 10v17.2h19.8v13.7H17v20.5c0 3.5.6 6.3 1.8 8.3 1.2 2.1 3.7 3.2 7.4 3.2 3.6 0 7.2-.7 10.6-2l2.3 13A38 38 0 0 1 12.3 85 17.5 17.5 0 0 1 1.6 71.9C.8 68.6.5 65 .5 61.7v-49Zm102.6 14.5a510.1 510.1 0 0 1-22.4 60.2c-1.4 3-3 5.7-4.7 8.5a27 27 0 0 1-5 5.7 18 18 0 0 1-6.4 3.3 33.3 33.3 0 0 1-20.7-1.3l3-13.1c2.8 1 5.7 1.5 8.7 1.5 3 0 5.2-.8 6.8-2.4a19 19 0 0 0 4-6.6c-9-17.9-16.3-36.6-21.9-55.8H62l2.6 9.3a443 443 0 0 0 9.9 29.1c2.3-6.2 4.3-12.5 6-18.9l5.4-19.5h17.2Zm46 29.6a20 20 0 0 0-3.4-12.3c-2.3-3-5.7-4.6-10.2-4.6a46 46 0 0 0-7.2.6v29.8c1.2.8 2.6 1.3 4 1.7 1.7.4 3.4.6 5 .6 7.9 0 11.8-5.3 11.8-15.8Zm16.8-.5a43 43 0 0 1-1.7 12.3c-1 3.5-2.6 6.7-4.8 9.6a22 22 0 0 1-8 6.2c-7.4 3-15.8 3-23.1-.3V106h-16.5V29.2a65 65 0 0 1 11.1-2.4c4.2-.6 8.5-.9 12.7-1 4.8 0 9 .8 12.8 2.2 7.3 2.7 13 8.4 15.5 15.7 1.3 3.8 2 8 2 12.6Zm48.7-5.8c-.1-1.4-.3-2.8-.7-4.1-.4-1.3-1-2.5-2-3.6-.8-1-2-2-3.1-2.5-1.5-.8-3.2-1-4.9-1-3-.2-6 1-8 3.4a8 8 0 0 0-2 3.6c-.5 1.3-.9 2.7-1.1 4.2h21.8Zm-38.7 6.3c0-5.2.7-9.7 2.3-13.6a27.8 27.8 0 0 1 25.6-17.6c8.2 0 14.7 2.6 19.5 7.6 4.8 5 7.2 12.5 7.2 22.4l-.1 3.1-.2 3h-37.4a11 11 0 0 0 4.7 8.3c2.8 2 6.6 3 11.3 3 5.5 0 10.9-1 16-3l2.3 13.5a62.8 62.8 0 0 1-20.5 3.6c-5.2 0-9.8-.7-13.7-2.3a25 25 0 0 1-15.3-16 38 38 0 0 1-1.8-12h.1Z"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("path", {
                                                    fill: "#5AB783",
                                                    d: "m269.7 83.5-28.2-22.2v-5.5l28.2-22 2.5 6.6-22.4 18.2 22.4 18.1-2.5 6.8Zm56.8-26.6c0-6.5-1.5-11.6-4.4-15.4a14.1 14.1 0 0 0-11.8-5.7c-5 0-9 2-11.8 5.7-3 3.8-4.4 9-4.4 15.4 0 6.5 1.5 11.6 4.4 15.4a14 14 0 0 0 11.8 5.7c5 0 9-2 11.8-5.7 3-3.8 4.4-9 4.4-15.4Zm10.7 0c0 4.2-.7 8.4-2 12.3a28.2 28.2 0 0 1-5.6 9.5 24.5 24.5 0 0 1-8.5 6.1c-6.9 3-14.7 3-21.6.1a24.4 24.4 0 0 1-8.5-6.2c-2.5-2.8-4.4-6-5.6-9.5-2.6-8-2.6-16.6 0-24.6a28 28 0 0 1 5.6-9.5 25 25 0 0 1 19.3-8.3c3.9 0 7.5.7 10.8 2.1a27.2 27.2 0 0 1 14.1 15.7c1.3 4 2 8.1 2 12.3Zm31-56.9c4.2 0 8.3.6 12.3 1.9l-1.9 8.8c-1.2-.6-2.4-1-3.7-1.3-1.6-.4-3.6-.6-6-.6-4.7 0-8 1.3-10 4-2 3.1-3 6.8-2.8 10.5v5h22v8.5h-22v48.8h-10.3V23c0-7.4 1.8-13 5.4-17 3.6-4 9.3-6 17-6Zm50.3 61.4-28.2 22-2.5-6.5 22.4-18.3-11.2-9c-3.7-3.2-7.4-6.2-11.2-9.2l2.5-6.7 28.2 22.1v5.6Z"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("path", {
                                                    fill: "#161326",
                                                    d: "M465.5 52.2c-3 11.2-6.2 22.3-9.9 33.3h-12.8a483 483 0 0 1-14.2-41c-1.8-5.6-3.5-11.3-5.1-17h17.4a1785 1785 0 0 0 9.2 37.9 450 450 0 0 0 5.5-19.9l2.4-9.4 2-8.6h12l2 8.6 2.3 9.4c1.7 6.7 3.4 13.4 5.3 20a433 433 0 0 0 7.4-29.3l2-8.7h17a875.7 875.7 0 0 1-15 47 216 216 0 0 1-4.3 11h-12.8l-5.5-16.7a329 329 0 0 1-4.8-16.6h-.1Zm86-1.5c-.1-1.4-.4-2.8-.8-4.1a10 10 0 0 0-5-6 9.4 9.4 0 0 0-4.9-1 9.8 9.8 0 0 0-10.1 7 18 18 0 0 0-1 4h21.7l.1.1Zm-38.8 6.2c0-5.1.8-9.6 2.4-13.5a29 29 0 0 1 6.3-9.6 28 28 0 0 1 19.1-7.8c8.3 0 14.8 2.5 19.6 7.5 4.8 5 7.2 12.5 7.2 22.2l-.1 3.2-.3 3h-37.3c.3 3.2 2 6.2 4.7 8 2.8 2 6.6 3 11.3 3a48 48 0 0 0 16-2.9l2.2 13.4a60.8 60.8 0 0 1-20.4 3.6c-5.3 0-9.8-.8-13.7-2.3a25 25 0 0 1-15.2-15.9 37.6 37.6 0 0 1-1.8-11.9Zm102-.8c0-10.6-4-16-11.7-16-3.2 0-6.3.9-9.1 2.4v29.9c2.4.4 4.8.6 7.2.5 4.5 0 7.9-1.5 10.2-4.6a20 20 0 0 0 3.4-12.2Zm16.8.4c0 4.6-.7 8.8-2 12.5a26 26 0 0 1-15.4 15.7 36 36 0 0 1-12.9 2.2 83 83 0 0 1-23.7-3.3v-81L593.8 0v28.9a29.5 29.5 0 0 1 23.1-.4c3.2 1.4 5.8 3.4 8 6 2.2 2.9 3.9 6.1 4.8 9.6 1.2 4 1.7 8.2 1.7 12.4h.1Z"
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("p", {
                            className: "my-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("a", {
                                    className: "underline underline-offset-1",
                                    href: "".concat(constants/* host */.h, "/regulamin/"),
                                    children: "Regulamin"
                                }),
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("a", {
                                    className: "underline underline-offset-1",
                                    href: "".concat(constants/* host */.h, "/polityka-prywatnosci/"),
                                    children: "Polityka prywatności"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("ul", {
                            className: "flex justify-center flex-row gap-x-3",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("li", {
                                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("a", {
                                        href: "https://facebook.com/typeofweb",
                                        className: "text-lg funny-focus rounded-sm ring-offset-yellow-300",
                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("svg", {
                                            "aria-label": "facebook",
                                            className: "icon icon-facebook2",
                                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("use", {
                                                xlinkHref: "#icon-facebook2"
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("li", {
                                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("a", {
                                        href: "https://youtube.com/c/typeofweb",
                                        className: "text-lg funny-focus rounded-sm ring-offset-yellow-300",
                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("svg", {
                                            "aria-label": "youtube",
                                            className: "icon icon-youtube",
                                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("use", {
                                                xlinkHref: "#icon-youtube"
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("li", {
                                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("a", {
                                        href: "https://instagram.com/michal_typeofweb",
                                        className: "text-lg funny-focus rounded-sm ring-offset-yellow-300",
                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("svg", {
                                            "aria-label": "instagram",
                                            className: "icon icon-instagram",
                                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("use", {
                                                xlinkHref: "#icon-instagram"
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("li", {
                                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("a", {
                                        href: "https://twitter.com/typeofweb",
                                        className: "text-lg funny-focus rounded-sm ring-offset-yellow-300",
                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("svg", {
                                            "aria-label": "twitter",
                                            className: "icon icon-twitter",
                                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("use", {
                                                xlinkHref: "#icon-twitter"
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("li", {
                                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("a", {
                                        href: "https://linkedin.com/in/mmiszczyszyn",
                                        className: "text-lg funny-focus rounded-sm ring-offset-yellow-300",
                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("svg", {
                                            "aria-label": "linkedin",
                                            className: "icon icon-linkedin",
                                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("use", {
                                                xlinkHref: "#icon-linkedin"
                                            })
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    }));
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [675,774,888,179], function() { return __webpack_exec__(5301); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);